import {
  type ConsentDetails,
  SERVICE_ID,
} from 'common/utils/getIsServiceConsentGiven';
import {
  type User,
  type IntegrationsSettings,
  loadAnalytics,
} from 'src/core/utils/analytics';
import { logger } from 'src/utils/datadog-log-wrapper';

type Props = {
  user?: User;
  company?: {
    id: string;
    type: string;
    created_from: string;
    organisation: {
      id: string;
    };
  };
  supervisor?: {
    name: string;
    email: string;
  };
};

type UCEvent = {
  detail: {
    consent: {
      fromUserAction: boolean;
      type: 'IMPLICIT' | 'EXPLICIT';
      status: 'ALL_ACCEPTED' | 'SOME_ACCEPTED' | 'NONE_ACCEPTED';
      updatedBy:
        | 'onAcceptAllServices'
        | 'onDenyAllServices'
        | 'onUpdateServices';
    };
    event: string;
  };
} & Event;

export const initUserCentrics = async ({
  user,
  company,
  supervisor,
}: Props) => {
  if (window.__ucCmp) {
    // Load analytics if the user has given consent
    try {
      const consentDetails: ConsentDetails =
        await window.__ucCmp.getConsentDetails();
      switch (consentDetails.consent.status) {
        case 'ALL_ACCEPTED':
          await loadAnalytics({
            user,
            company,
            supervisor,
          });
          break;
        case 'SOME_ACCEPTED':
        case 'SOME_DENIED':
          {
            const integrationsSettings: IntegrationsSettings = {
              All: false,
              'Google Analytics':
                consentDetails.services[SERVICE_ID.googleAnalytics]?.consent
                  ?.given,
              'Amplitude (Actions)':
                consentDetails.services[SERVICE_ID.amplitude]?.consent?.given,
              SatisMeter:
                consentDetails.services[SERVICE_ID.satisMeter]?.consent?.given,
              'Segment.io': true,
              'Actions Slack': true,
              'Webhooks (Actions)': true,
            };
            await loadAnalytics({
              user,
              company,
              supervisor,
              integrationsSettings,
            });
          }
          break;
        default:
          // considered as all denied
          break;
      }
    } catch {
      // do nothing
    }
  }
  // forcing load regardless of the consent for non-production environments when analyticsEnabled
  else if (
    appConfig.environmentName !== 'production' &&
    appConfig.analyticsEnabled
  ) {
    await loadAnalytics({
      user,
      company,
      supervisor,
    });
  }

  window.addEventListener('UC_CONSENT', ((event: UCEvent) => {
    if (
      event.detail.consent.fromUserAction &&
      event.detail.consent.type === 'EXPLICIT'
    ) {
      logger.info('UC_CONSENT listener reload', {
        team: 'travel-and-expenses',
        scope: 'auth::reload',
        eventDetail: event.detail,
        event,
      });
      window.location.reload();
    }
  }) as EventListener);
};
